import React from 'react';

import {
	makeEmptySelectionGetInitialContext,
	makeEmptySelectionTriggerPromptRequest,
	makeRangeSelectionGetInitialContext,
	makeRangeSelectionTriggerPromptRequest,
} from '../../../config-items/config-item-context-and-request';
import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { Logo } from '../../../ui/components/Logo/Logo';
import { createInsertBelow, createReplace } from '../../config-item-actions/markdown';
import { isMinLength } from '../../config-item-visible/visibility-utils';

import { messages } from './messages';

const intentSchemaId = 'make_longer.json';

export const makeLongerEmptyConfigItem = createEditorPluginAIConfigItemMarkdown<'empty'>({
	key: CONFIG_ITEM_KEYS.MAKE_LONGER,
	title: messages.title,
	description: messages.description,
	icon: ({ shownAt }) => <Logo />,
	statusLozengeType: 'beta',
	selectionType: 'empty',
	isVisible: ({ editorView, positions }) => isMinLength({ editorView, minLength: 1, positions }),
	getInitialContext: makeEmptySelectionGetInitialContext({ intentSchemaId }),
	triggerPromptRequest: makeEmptySelectionTriggerPromptRequest({ intentSchemaId }),
	getBackendModel: () => 'assistance-service',
	actions: [
		createInsertBelow({ appearance: 'secondary' }),
		createReplace({ appearance: 'primary' }),
	],
});

export const makeLongerRangeConfigItem = createEditorPluginAIConfigItemMarkdown<'range'>({
	key: CONFIG_ITEM_KEYS.MAKE_LONGER,
	title: messages.title,
	description: messages.description,
	icon: ({ shownAt }) => <Logo />,
	statusLozengeType: 'beta',
	selectionType: 'range',
	isVisible: ({ editorView, positions }) => isMinLength({ editorView, minLength: 1, positions }),
	getInitialContext: makeRangeSelectionGetInitialContext({ intentSchemaId }),
	triggerPromptRequest: makeRangeSelectionTriggerPromptRequest({ intentSchemaId }),
	getBackendModel: () => 'assistance-service',
	actions: [
		createInsertBelow({ appearance: 'secondary' }),
		createReplace({ appearance: 'primary' }),
	],
});
